<?xml version="1.0" encoding="UTF-8"?>
<svg id="js-drinking-water-graphic"
    width="100%"
    height="100%"
    style="max-height: 500px;"
    version="1.1"
    viewBox="-100 0 396 330"
    font-family="sans-serif"
    preserveAspectRatio="xMinYMax meet"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    {{> Y_AXIS axisConfig}}

    {{#COMPARE activeTab '===' 'day'}}
        {{> DRINKING_WATER_HANDLE day.on}}
        {{> DRINKING_WATER_HANDLE day.off}}
        {{> DRINKING_WATER_HANDLE day.chargingTemp}}

        {{#unless readOnly}}
        {{> DRINKING_WATER_NIGHT_MARKER night.on}}
        {{> DRINKING_WATER_NIGHT_MARKER night.off}}
        {{> DRINKING_WATER_NIGHT_MARKER night.chargingTemp}}
        {{/unless}}
    {{/COMPARE}}
    {{#COMPARE activeTab '===' 'night'}}
        {{> DRINKING_WATER_HANDLE night.on}}
        {{> DRINKING_WATER_HANDLE night.off}}
        {{> DRINKING_WATER_HANDLE night.chargingTemp}}

        {{#unless readOnly}}
        {{> DRINKING_WATER_DAY_MARKER day.on}}
        {{> DRINKING_WATER_DAY_MARKER day.off}}
        {{> DRINKING_WATER_DAY_MARKER day.chargingTemp}}
        {{/unless}}
    {{/COMPARE}}
</svg>
